import { findTriggerEvent } from "../utils/commonUtils";
import { shallowCopy } from "./blueprint"
const shortUUiD = require("short-uuid");

export const cloneTransaction = (transactions, events, handlers, delegates, selectedTransaction, inputData) => {
    
    const newTransactions = shallowCopy(transactions);
    const newEvents = shallowCopy(events);
    const newHandlers = shallowCopy(handlers);
    const newSelectedTransaction = shallowCopy(selectedTransaction);
    
    const allDelegateIds = delegates.map(delegate => delegate.id);
    const delegatesInSelectedTransaction = newSelectedTransaction.clusterlets.
                                            filter(clusterlet => allDelegateIds.includes(clusterlet.id)).
                                            map(i => i.id);
    const selectedTransactionEventIds = newSelectedTransaction.events.map(event => event.id);
    const nestedTransactionIds = newSelectedTransaction.nestedTransactions.map(transaction => transaction.id);

    // Nested transactions
    let { copiedNestedTransactions,    // copied nested transactions with new id
        nestedTransactionsChangedIds,  // nested transactions old id and new id object
        nestedTransactionEventsChangedIds, // old id and new id object of events associated with nested transaction 
        copiedNestedTransactionEvents  // copied events associated with nested transaction with new id
    } = copyNestedTransactions(newTransactions, newEvents, nestedTransactionIds); 
    
    // Events
    const {copiedEvents: copiedSelectedTransactionEvents,  // copied events associated with selected transaction with new id 
        changedIds: selectedTransactionEventChangedIds,   // old id and new id object of events associated with selected transaction
        firstEvents                                      // first event ids for changing the function name in handlers
    } = copyEvents(newEvents, selectedTransactionEventIds, delegatesInSelectedTransaction, inputData.name); 
    const modifiedEvents = modifyObjectsWithNewId(newSelectedTransaction.events, selectedTransactionEventChangedIds);  // selected transaction event id change with new id
    const totalCopiedEvents = [...copiedSelectedTransactionEvents, ...copiedNestedTransactionEvents];   // selected transaction events + child transaction events
    
    // Handlers
    const eventsChangedIds = {...selectedTransactionEventChangedIds, ...nestedTransactionEventsChangedIds};
    const totalCopiedHandlers = copyHandlers(newHandlers, eventsChangedIds, firstEvents, inputData.name);
    
    //Cloned Transactions
    const modifiedNestedTransactions = modifyObjectsWithNewId(newSelectedTransaction.nestedTransactions, nestedTransactionsChangedIds);  // nested transaction id change with new id
    let clonedTransaction = {
        ...selectedTransaction,
        id: shortUUiD.generate(),
        events: modifiedEvents,
        name: inputData.name, 
        description: inputData.description,
        nestedTransactions: modifiedNestedTransactions
    };  

    return { clonedTransaction, copiedNestedTransactions, totalCopiedEvents, totalCopiedHandlers };

}

// For copy events
const copyEvents = (allEvents, eventsIdsToCopy, delegates, name) => {
    let changedIds = {};
    let firstEvents = {};  // {oldeventId: eventname}
    const copiedEvents = allEvents.filter(event => {
        if(eventsIdsToCopy.includes(event.id)) {
            if(delegates.includes(event.src)) {
                firstEvents[event.id] = event.name;   
                event.name = `${name}_${event.name}`;
            }
            let newId = shortUUiD.generate();
            changedIds[event.id] = newId;
            event.id = newId;
            return event;
        }
    });
    return { copiedEvents, changedIds, firstEvents };
}

// Function to modify the function name of a handler 
const updateHandlerData = (handler, eventName, transactionName) => {
    let dataToEdit = handler.data;
    let re = new RegExp(`${handler.type}_${eventName}`, "g");
    let editedData = dataToEdit.replace(re, `${handler.type}_${transactionName}_${eventName}`);
    return editedData;
}

const copyHandlers = (allHandlers, eventsChangedIds, firstEvents, transactionName) => {
    const associatedEventids = Object.keys(eventsChangedIds);
    const firstEventsIds = Object.keys(firstEvents);
    const copiedHanldlers = allHandlers.filter(handler => {
        if(associatedEventids.includes(handler.event)) {
            if(firstEventsIds.includes(handler.event)) {
                const eventName = firstEvents[handler.event];
                handler.data = updateHandlerData(handler, eventName, transactionName)  // For modify the function name of handlers of first event 
            }
            handler.id = shortUUiD.generate();
            handler.event = eventsChangedIds[handler.event];
            return handler;
        }
    });
    return copiedHanldlers;
}

const modifyObjectsWithNewId = (array, changedIds) => {
    let modifiedArray = array.map(obj => {
        obj.id = changedIds[obj.id];
        return obj
    });
    return modifiedArray;
}

//For copy child transactions
const copyNestedTransactions = (allTransactions, allEvents, nestedTransactionIds) => {
    let nestedTransactionsChangedIds = {};
    let nestedTransactionEventsChangedIds = {};
    let copiedNestedTransactionEvents = [];
    const copiedNestedTransactions = allTransactions.filter(transaction => {
        if(nestedTransactionIds.includes(transaction.id)) {
            const eventIds = transaction.events.map(event => event.id);
            let { copiedEvents, changedIds } = copyEvents(allEvents, eventIds, []);   // For copy events associated with child transaction
            transaction.events = modifyObjectsWithNewId(transaction.events, changedIds);
            copiedNestedTransactionEvents = [...copiedNestedTransactionEvents, ...copiedEvents];
            nestedTransactionEventsChangedIds = { ...nestedTransactionEventsChangedIds, ...changedIds };
            let newId = shortUUiD.generate();
            nestedTransactionsChangedIds[transaction.id] = newId;
            transaction.id = newId;
            return transaction;
        }
    });

    return { copiedNestedTransactions, nestedTransactionsChangedIds, nestedTransactionEventsChangedIds, copiedNestedTransactionEvents };
}

export const findResponseEventsInTransaction = ({transactions, delegates, events, transactionId}) => {
    // console.log({transactions})
    // console.log({delegates})
    // console.log({events})
    // console.log({transactionId})

    try {
        
            const transactionData = transactions.find(tr => tr._id == transactionId);
            if(transactionData == undefined){
                return []
            }
            const nestedTxns = transactionData.nestedTransactions
            let nestedEvents = []
            nestedTxns.forEach(ntr => {
                let nestedTxn = transactions.find(tr => tr._id == ntr.id);
                if (nestedTxn) {
                    nestedEvents = [...nestedEvents, ...nestedTxn.events];
                }
            });
            const transactionEvents = [...transactionData.events, ...nestedEvents];

            const modifiedEvents = transactionEvents.map(trEvent => {
                const eventData = JSON.parse(JSON.stringify(events.find(ele => ele._id == trEvent.id)))
                eventData.order = trEvent.order;

                return eventData;
            }).filter(item => item !== undefined).sort((a, b) => a.order - b.order);
            const triggerEvent = findTriggerEvent({ transaction: transactionData, events: modifiedEvents, clusterlets: delegates })
            
            let responseEvents = [];
            if (triggerEvent) {
                responseEvents = modifiedEvents.filter(item => item.dst == triggerEvent.src);
            }
            
            return responseEvents;

    } catch (error) {
        console.error(error);       
    }
}
